// extracted by mini-css-extract-plugin
module.exports = {"seamless-technology":"styles_seamless-technology__2AolM"};